export default {
  // Page titles
  overview: {
    title: 'データ概要',
    jobOverview: '求人概要',
    jobOverviewInfo: '作成済みの求人に基づく集計',
    selectionProgress: '選考進捗',
    selectionProgressInfo: '進行中選考ベースの集計（入社済み・終了済み除く）',
    jobSelectionProgress: '求人別選考進捗',
    conversionRate: '求人別選考通過率',
    conversionFunnel: '選考通過率',
    conversionFunnelInfo: '全選考履歴ベースの集計',
    notRecruitedJobs: '公開待ち求人数',
    recruitingJobs: '公開中求人数',
    closedJobs: '公開停止求人数',
    openToAgentJobs: 'エージェント共有求人数',
    interviewingJobs: '選考中',
    totalCandidates: '候補者総数',
    documentReview: '書類選考',
    interview: '面接',
    internalSelection: '内定',
    entry: '入社',
    rejection: '不採用',
    jobTitle: '求人',
    recruitCount: '採用人数',
    enteredCount: '入社済み',
    inProgress: '選考中',
    interviewPending: '面接日程調整中',
    interviewWaitAccept: '面接日程確定待ち',
    interviewWaiting: '面接待ち',
    interviewAdjust: '面接日程再調整',
    interviewExpired: '面接日程失効',
    internalOffer: '内定',
    confirmEntryDate: '入社日確認待ち',
    confirmEntry: '入社待ち',
    totalApplications: '総応募数',
    documentReviewRate: '書類選考',
    interviewRate: '面接',
    internalRate: '内定',
    entryRate: '入社',
    pendingOnboarding: '入社待ち',
    overallConversionRate: '全体選考通過率',
    updateTime: '更新日時',
    downloadExcel: 'エクセル書き出し',
  },
  headhunter: {
    title: 'エージェント推薦',
    placeholder: '開発中...',
    progress: 'エージェント推薦選考進捗',
    progressInfo: '進行中選考（エージェント推薦のみ）ベースの集計（入社済み・中止除く）',
    differentHeadhunters: 'エージェント別推薦選考進捗',
    headhunterCompany: 'エージェント',
    conversion: 'エージェント推薦選考通過率',
    conversionInfo: 'エージェント推薦ベースの全選考履歴集計',
    differentHeadhuntersConversion: 'エージェント別選考通過率',
    totalApplications: '総応募数',
    joined: '入社済み',
    chartTitle: '全体選考通過率',
    allHeadhunters: 'すべての猟師',
  },
  internal: {
    title: '自社応募',
    placeholder: '開発中...',
    progress: '自社応募選考進捗',
    progressInfo: '進行中選考（自社応募のみ）ベースの集計（入社済み・中止除く）',
    differentChannels: '応募チャンネル別選考進捗',
    channel: '応募チャンネル',
    conversion: '自社応募選考通過率',
    conversionInfo: '自社応募のすべての歴史選考記録統計',
    differentChannelsConversion: '応募チャンネル別選考通過率',
    totalApplications: '総応募数',
    joined: '入社済み',
    chartTitle: '全体選考通過率',
  },
  myBoard: {
    title: 'myダッシュボード',
    placeholder: '開発中...',
    myResponsible: '担当選考進捗',
    myResponsibleInfo: '進行中選考（自分担当のみ）ベースの集計（入社済み・終了済み除く）',
    differentJobs: '求人別選考進捗',
    differentHeadhunters: 'エージェント別推薦選考進捗',
    headhunterCompany: 'エージェント',
    internalDifferentChannels: '自社応募・応募チャンネル別選考進捗',
    channel: '応募チャンネル',
  },
  agent: {
    title: 'データ概要',
    recruitmentOverview: '採用概要',
    recruitmentOverviewInfo: '共有中の求人および応募状況に基づく集計',
    jobAndApplicationSummary: '求人応募一覧',
    recruitingCompany: '募集企業',
    openPositions: '共有求人数',
    totalRecruitment: '採用総人数',
    totalApplications: '総応募数',
    enteredCount: '入社済み',
    selectionProgress: '選考進捗',
    selectionProgressInfo: '進行中選考ベースの集計（入社済み・終了済み除く）',
    differentCompaniesProgress: '企業別選考進捗',
    differentManagersProgress: '担当者別選考進捗',
    manager: '担当者',
    inProgress: '選考中',
    documentReview: '書類選考',
    interviewPending: '面接日程調整中',
    interviewWaitAccept: '面接日程確定待ち',
    interviewWaiting: '面接待ち',
    interview: '面接',
    interviewAdjust: '面接日程再調整',
    interviewExpired: '面接日程失効',
    internalOffer: '内定',
    confirmEntryDate: '入社日確認待ち',
    confirmEntry: '入社待ち',
    conversionAnalysis: '選考通過率',
    conversionAnalysisInfo: '全選考履歴ベースの集計',
    overallConversionRate: '全体選考通過率',
    differentCompaniesConversion: '企業別選考通過率',
    differentManagersConversion: '担当者別選考通過率',
    myBoardTitle: 'myダッシュボード',
    jobAndMyApplicationSummary: '採用概要',
    jobAndMyApplicationTableTitle: '求人応募一覧',
    jobAndMyApplicationSummaryInfo: '共有中の求人および自分が担当する応募に基づく集計',
    mySelectionProgress: '選考進捗',
    mySelectionProgressInfo: '進行中選考（自分担当のみ）ベースの集計（入社済み・中止除く）',
    differentJobsProgress: '求人別選考進捗',
    jobInfo: '求人',
    myConversionAnalysis: '選考通過率',
    myConversionAnalysisInfo: '担当の全選考履歴ベースの集計',
    differentJobsConversion: '求人別選考通過率',
  },
};
